import React from 'react';
interface LogoProps {
  className?: string;
  light?: boolean;
}
export function Logo({
  className = 'h-8 w-auto',
  light = false
}: LogoProps) {
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-62">
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-500 flex-shrink-0" aria-hidden="true" data-id="element-63">
        <rect width="40" height="40" rx="8" className={light ? 'fill-white/10' : 'fill-slate-900'} data-id="element-64" />
        <path d="M10 28L16 22L22 28L32 14" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-65" />
        <path d="M32 14V20" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-66" />
        <path d="M32 14H26" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-67" />
        <circle cx="10" cy="28" r="2" className="fill-current" data-id="element-68" />
        <circle cx="16" cy="22" r="2" className="fill-current" data-id="element-69" />
        <circle cx="22" cy="28" r="2" className="fill-current" data-id="element-70" />
        <circle cx="32" cy="14" r="2" className="fill-current" data-id="element-71" />
      </svg>
      <div className="flex flex-col leading-none" data-id="element-72">
        <span className={`font-bold text-lg tracking-tight transition-colors ${light ? 'text-white' : 'text-slate-900'}`} data-id="element-73">
          Smart Market
        </span>
        <span className={`text-xs font-semibold tracking-widest uppercase transition-colors ${light ? 'text-green-400' : 'text-green-600'}`} data-id="element-74">
          Digital
        </span>
      </div>
    </div>;
}